import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface PageHeroProps {
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  children?: ReactNode;
  className?: string;
  contentClassName?: string;
}

const PageHero = ({
  title,
  description,
  eyebrow,
  children,
  className,
  contentClassName,
}: PageHeroProps) => {
  return (
    <section className={cn("relative isolate bg-dark-surface", className)}>
      <div
        className="page-hero-backdrop absolute inset-0 -z-10 bg-cover bg-center"
      />
      <div className={cn("container mx-auto px-4 py-16 md:py-20", contentClassName)}>
        <div className="max-w-3xl text-white">
          {eyebrow && (
            <p className="mb-4 inline-flex rounded-full border border-white/20 bg-white/10 px-3 py-1 text-sm font-medium text-white/85 backdrop-blur">
              {eyebrow}
            </p>
          )}
          <h1
            className="font-heading text-[length:var(--text-h1)] font-bold leading-tight text-white"
          >
            {title}
          </h1>
          {description && (
            <p className="mt-4 max-w-2xl text-[length:var(--text-body)] text-white/80">
              {description}
            </p>
          )}
        </div>
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
};

export default PageHero;
